import * as React from 'react';
import styled from 'styled-components';

const DotSeparator: React.FC<{ marginX?: number }> = ({ marginX }) => (
  <StyledInterpunct $marginX={marginX}>&#183;</StyledInterpunct>
);

export default DotSeparator;

const StyledInterpunct = styled.span<{ $marginX?: number }>`
  font-size: 22px;
  font-weight: 800;
  line-height: 14px;
  position: relative;
  top: 2px;
  ${({ $marginX }) =>
    $marginX && `margin-left: ${$marginX}px; margin-right: ${$marginX}px;`}
`;
